// extracted by mini-css-extract-plugin
export default {"wrapper":"gc","textRight":"hc","listWrapper":"ic","icon":"jc","heading":"kc","para":"lc","list":"mc","blinking":"nc"};